import { render, staticRenderFns } from "./ServiziBrevi.vue?vue&type=template&id=6be05096&"
import script from "./ServiziBrevi.vue?vue&type=script&lang=js&"
export * from "./ServiziBrevi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports